import { Injectable } from '@angular/core';
import { ReplaySubject } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { OpportunityType } from '../../sales-opportunities/interface';

@Injectable()
export class OpportunityTypeFilterService {
  private readonly selectedTypes$$ = new ReplaySubject<OpportunityType[]>(1);
  readonly selectedTypes$ = this.selectedTypes$$.asObservable();
  readonly selectedTypeNames$ = this.selectedTypes$.pipe(
    filter((types) => Boolean(types)),
    map((types) => types.map((type) => type.displayName).join(', ')),
  );

  setTypeSelection(types: OpportunityType[]): void {
    this.selectedTypes$$.next(types);
  }

  clearOpportunityTypeSelection(): void {
    this.setTypeSelection([]);
  }
}
